import { render, staticRenderFns } from "./BudgetSpendBreakdown.vue?vue&type=template&id=517706e0&scoped=true"
import script from "./BudgetSpendBreakdown.vue?vue&type=script&lang=js"
export * from "./BudgetSpendBreakdown.vue?vue&type=script&lang=js"
import style0 from "./BudgetSpendBreakdown.vue?vue&type=style&index=0&id=517706e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517706e0",
  null
  
)

export default component.exports